import React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import BetaFeedbackModal from "../../reusable/betaFeedbackModal";

import setUpAxios from "../../../helperFunctions/helperFunctions";

export default class FeedbackCard extends React.Component<any, any> {
  render() {
    return (
      <>
        <div className="card feedback-card">
          <div className="feedback-card-content">
            <div className="feedback-blurb">
              {i18n.translate("analyticsv2.feedback_card.solicit_feedback")}
            </div>
            <a
              href="#"
              data-toggle="modal"
              data-target={`#${this.getModalId()}`}
              className="btn btn-large btn-approve"
            >
              {i18n.translate("analyticsv2.feedback_card.solicit_feedback_cta")}
            </a>
          </div>
        </div>
        {this.renderModal()}
      </>
    );
  }

  renderModal = () => {
    return (
      <BetaFeedbackModal
        title={this.getModalTitle()}
        id={this.getModalId()}
        dataBackdrop={false}
        feature={this.getBetaFeedbackFeature()}
        setUpAxios={setUpAxios}
      />
    );
  };

  getBetaFeedbackFeature = () => {
    return "analytics_v2";
  };

  getModalId = () => {
    return "beta-feedback-modal";
  };

  getModalTitle = () => {
    return i18n.translate("analyticsv2.feedback_card.how_can_we_improve");
  };
}
